import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppWidget from "./components/WhatsAppWidget";

import Home from "./pages/Home";
import DayTours from "./pages/DayTours";
import DayTourDetail from "./pages/DayTourDetail";
import WaterActivities from "./pages/WaterActivities";
import Hotels from "./pages/Hotels";
import HotelDetail from "./pages/HotelDetail";
import Packages from "./pages/Packages";
import PackageCategory from "./pages/PackageCategory";
import PackageDetails from "./pages/PackageDetails";
import Transfers from "./pages/Transfers";
import CarRentals from "./pages/CarRentals";
import Contact from "./pages/Contact";
import About from "./pages/About";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";

export default function App() {
  return (
    <>
      <ScrollToTop/>
      <Navbar />
      <main className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/day-tours" element={<DayTours />} />
          <Route path="/day-tours/:id" element={<DayTourDetail />} />
          <Route path="/water-activities" element={<WaterActivities />} />
          <Route path="/hotels" element={<Hotels />} />
          <Route path="/hotels/:id" element={<HotelDetail />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/packages/:category/:id" element={<PackageDetails />} />
          <Route path="/packages/:category" element={<PackageCategory />} />
          <Route path="/transfers" element={<Transfers />} />
          <Route path="/car-rentals" element={<CarRentals />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppWidget phone="+255718665620" message="Hi! Are you available to help me plan a Zanzibar tour?" />
    </>
  );
}
